import React from 'react';

function Placeholder({ title, desc }) {
  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-8 min-h-[420px]">
      <h3 className="text-xl font-bold text-[#0f1f45]">{title}</h3>
      <p className="text-sm text-gray-500 mt-2 max-w-3xl">{desc}</p>

      <div className="mt-12 border border-dashed border-gray-200 rounded-xl p-10 text-center text-gray-400 text-sm">
        This section is ready for Phase 1 development.
      </div>
    </div>
  );
}

export default Placeholder;
